/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownCourseStructure } from '../models/db_DropdownCourseStructure';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CourseStructures {
    /**
     * Get a list of course structures
     * @returns db_DropdownCourseStructure OK
     * @throws ApiError
     */
    public static listCourseStructures(): CancelablePromise<Array<db_DropdownCourseStructure>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/course-structures',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
